import BaseValidator from "./BaseValidator";

export default class RegexValidator extends BaseValidator {
    _getDefaultOptions() {
        return {
            regexPattern: null,
            regexErrorMessage: null
        };
    }

    /**
     *
     * @param value
     * @param t - translation function
     * @return {Array}
     */
    validate(value, t = null) {
        const errors = [];
        if (this._options.regexPattern) {
            let regExp;
            try {
                regExp = new RegExp(this._options.regexPattern, "i");
            } catch (e) {
                // The pattern can come from survey config authored by non-technical creators, so
                // an invalid regex (e.g. "*", "[") must not crash the kiosk. Fail open: skip regex
                // validation (accept the value) and log so the bad pattern is visible.
                // eslint-disable-next-line no-console
                console.warn(
                    `RegexValidator: ignoring invalid regexPattern "${this._options.regexPattern}": ${e.message}`
                );
                return errors;
            }

            if (!regExp.test(String(value))) {
                let errorText = null;

                // Try custom error message as i18n token first
                if (this._options.regexErrorMessage && t) {
                    errorText = t(this._options.regexErrorMessage);
                }

                // If custom i18n failed, use custom message directly
                if (!errorText && this._options.regexErrorMessage) {
                    errorText = this._options.regexErrorMessage;
                }

                // Fall back to standard validation key
                if (!errorText) {
                    errorText = t ? t("validation.regex.invalid") : null;
                }

                // Final fallback
                errorText = errorText || "Please enter a valid value";

                if (errorText) {
                    errors.push(errorText);
                }
            }
        }

        return errors;
    }
}
